/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3fPb } from "../eigen_lcm/Vector3f";
import { Uuid } from "../uuid_util/uuid";
import { PlanPoint } from "./plan_point";
import {
  ScanWaypointType_Enum,
  scanWaypointType_EnumFromJSON,
  scanWaypointType_EnumToJSON,
} from "./scan_waypoint_type";
import { TrajectoryMotionInfo } from "./trajectory_motion_info";
import { VerticalViewpointData } from "./vertical_viewpoint_data";
import { WideBaselineRangeInfo } from "./wide_baseline_range_info";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScanWaypoint {
  globalMapTCamera: Vector3fPb | undefined;
  lookAtPointNormal: PlanPoint | undefined;
  verticalViewpointData: VerticalViewpointData | undefined;
  type: ScanWaypointType_Enum;
  trajInfo: TrajectoryMotionInfo | undefined;
  wideBaselineRangeInfo: WideBaselineRangeInfo | undefined;
  uuid: Uuid | undefined;
}

function createBaseScanWaypoint(): ScanWaypoint {
  return {
    globalMapTCamera: undefined,
    lookAtPointNormal: undefined,
    verticalViewpointData: undefined,
    type: 0,
    trajInfo: undefined,
    wideBaselineRangeInfo: undefined,
    uuid: undefined,
  };
}

export const ScanWaypoint = {
  encode(message: ScanWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.globalMapTCamera !== undefined) {
      Vector3fPb.encode(message.globalMapTCamera, writer.uint32(10).fork()).ldelim();
    }
    if (message.lookAtPointNormal !== undefined) {
      PlanPoint.encode(message.lookAtPointNormal, writer.uint32(18).fork()).ldelim();
    }
    if (message.verticalViewpointData !== undefined) {
      VerticalViewpointData.encode(message.verticalViewpointData, writer.uint32(26).fork()).ldelim();
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.trajInfo !== undefined) {
      TrajectoryMotionInfo.encode(message.trajInfo, writer.uint32(50).fork()).ldelim();
    }
    if (message.wideBaselineRangeInfo !== undefined) {
      WideBaselineRangeInfo.encode(message.wideBaselineRangeInfo, writer.uint32(58).fork()).ldelim();
    }
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.globalMapTCamera = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.lookAtPointNormal = PlanPoint.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.verticalViewpointData = VerticalViewpointData.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.trajInfo = TrajectoryMotionInfo.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.wideBaselineRangeInfo = WideBaselineRangeInfo.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScanWaypoint {
    return {
      globalMapTCamera: isSet(object.globalMapTCamera) ? Vector3fPb.fromJSON(object.globalMapTCamera) : undefined,
      lookAtPointNormal: isSet(object.lookAtPointNormal) ? PlanPoint.fromJSON(object.lookAtPointNormal) : undefined,
      verticalViewpointData: isSet(object.verticalViewpointData)
        ? VerticalViewpointData.fromJSON(object.verticalViewpointData)
        : undefined,
      type: isSet(object.type) ? scanWaypointType_EnumFromJSON(object.type) : 0,
      trajInfo: isSet(object.trajInfo) ? TrajectoryMotionInfo.fromJSON(object.trajInfo) : undefined,
      wideBaselineRangeInfo: isSet(object.wideBaselineRangeInfo)
        ? WideBaselineRangeInfo.fromJSON(object.wideBaselineRangeInfo)
        : undefined,
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
    };
  },

  toJSON(message: ScanWaypoint): unknown {
    const obj: any = {};
    if (message.globalMapTCamera !== undefined) {
      obj.globalMapTCamera = Vector3fPb.toJSON(message.globalMapTCamera);
    }
    if (message.lookAtPointNormal !== undefined) {
      obj.lookAtPointNormal = PlanPoint.toJSON(message.lookAtPointNormal);
    }
    if (message.verticalViewpointData !== undefined) {
      obj.verticalViewpointData = VerticalViewpointData.toJSON(message.verticalViewpointData);
    }
    if (message.type !== 0) {
      obj.type = scanWaypointType_EnumToJSON(message.type);
    }
    if (message.trajInfo !== undefined) {
      obj.trajInfo = TrajectoryMotionInfo.toJSON(message.trajInfo);
    }
    if (message.wideBaselineRangeInfo !== undefined) {
      obj.wideBaselineRangeInfo = WideBaselineRangeInfo.toJSON(message.wideBaselineRangeInfo);
    }
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanWaypoint>, I>>(base?: I): ScanWaypoint {
    return ScanWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanWaypoint>, I>>(object: I): ScanWaypoint {
    const message = createBaseScanWaypoint();
    message.globalMapTCamera = (object.globalMapTCamera !== undefined && object.globalMapTCamera !== null)
      ? Vector3fPb.fromPartial(object.globalMapTCamera)
      : undefined;
    message.lookAtPointNormal = (object.lookAtPointNormal !== undefined && object.lookAtPointNormal !== null)
      ? PlanPoint.fromPartial(object.lookAtPointNormal)
      : undefined;
    message.verticalViewpointData =
      (object.verticalViewpointData !== undefined && object.verticalViewpointData !== null)
        ? VerticalViewpointData.fromPartial(object.verticalViewpointData)
        : undefined;
    message.type = object.type ?? 0;
    message.trajInfo = (object.trajInfo !== undefined && object.trajInfo !== null)
      ? TrajectoryMotionInfo.fromPartial(object.trajInfo)
      : undefined;
    message.wideBaselineRangeInfo =
      (object.wideBaselineRangeInfo !== undefined && object.wideBaselineRangeInfo !== null)
        ? WideBaselineRangeInfo.fromPartial(object.wideBaselineRangeInfo)
        : undefined;
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
